/**
 * CTA / offer string fragments assembled with live fees from status.
 * Kept out of CMS so price formatting stays consistent with
 * `roundOffAndFormatNumberWithCurrency` output.
 */
export const ELITE_CTA_PREFIX = 'Get Elite at '
export const ELITE_FEE_SUFFIX_YEARLY = '/yr+GST'
export const ELITE_FEE_SUFFIX_MONTHLY = '/mo+GST'
export const ELITE_PRIME_CTA_PREFIX = 'Upgrade to Prime at '
export const ELITE_PRIME_OFFER_CTA_PREFIX = 'Get Prime at '
export const ELITE_PRIME_UPGRADE_CTA_LABEL = 'Upgrade to Prime'
export const ELITE_PRIME_FEE_SUFFIX = '/yr + GST'
export const ELITE_PRIME_UPGRADE_ADJUSTMENT_SUFFIX = ' adjusted from remaining Elite plan'
export const ELITE_PRIME_UPGRADE_ADJUSTMENT_INFO =
  'We credit the unused portion of your current Elite plan toward this upgrade.'
export const ELITE_FAMILY_BLOCKED_CTA_LABEL = 'Upgrade to Elite'
export const ELITE_FAMILY_BLOCKED_NOTE = 'You need to be an Elite member to make this purchase'
export const ELITE_PRIME_FAMILY_BLOCKED_CTA_LABEL = 'Upgrade to Prime'
export const ELITE_PRIME_FAMILY_BLOCKED_NOTE = 'You need to be a Prime member to make this purchase'
export const ELITE_PRIME_UPGRADE_MAX_SLAB_INFO =
  'Your Elite Prime fee is capped at the maximum for your portfolio slab.'
